import { createStyles, Theme } from '@material-ui/core/styles';

export const styles = ({
  palette: {
    primary: { main },
    common: { white },
  },
  custom: {
    fontSizes: { heading, body, bodyG },
    palette: { colorSupportSteel },
  },
  spacing: { unit },
}: Theme) =>
  createStyles({
    card: {
      backgroundColor: 'transparent',
      width: '100%',
      padding: 15,
      flex: 1,
      flexDirection: 'column',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      minHeight: '0%',
      boxShadow: 'none',
      fontWeight: 500,
      fontSize: bodyG,
      color: colorSupportSteel,
      textAlign: 'center',
    },
    title: {
      fontWeight: 600,
      fontSize: heading,
      color: main,
      marginBottom: 3 * unit,
      marginTop: 2 * unit,
      textAlign: 'center',
      width: '100%',
    },
    subtitle: {
      color: colorSupportSteel,
      fontSize: body,
      fontWeight: 500,
      marginBottom: 2 * unit,
      textAlign: 'center',
      width: '100%',
    },
    icon: {
      marginRight: unit,
    },
    label: {
      textTransform: 'uppercase',
    },
  });
